import { useEffect } from "react";
import { APP_DOMAIN } from "../../utls/constants";

interface UsePublicPageSeoParams {
  path?: string;
  title?: string;
  description?: string;
  noindex?: boolean;
}

/**
 * Hook pour gérer les meta tags SEO des pages publiques
 * Ajoute automatiquement canonical et robots tags
 * @param noindex - Si true, utilise "noindex, nofollow" au lieu de "index, follow"
 */
const usePublicPageSeo = ({ path, title, description, noindex = false }: UsePublicPageSeoParams = {}) => {
  useEffect(() => {
    // Canonical URL
    const canonicalUrl = path 
      ? `https://www.${APP_DOMAIN}${path}`
      : window.location.href;

    // Supprimer les anciennes canonical tags
    document.querySelectorAll('link[rel="canonical"]').forEach((link) => link.remove());
    
    const linkCanonical = document.createElement("link");
    linkCanonical.rel = "canonical";
    linkCanonical.href = canonicalUrl;
    document.head.appendChild(linkCanonical);

    // Robots meta tag
    let metaRobots = document.querySelector('meta[name="robots"]') as HTMLMetaElement;
    if (!metaRobots) {
      metaRobots = document.createElement("meta");
      metaRobots.name = "robots";
      document.head.appendChild(metaRobots);
    }
    metaRobots.content = noindex ? "noindex, nofollow" : "index, follow";

    // Optionnel: définir title et description si fournis
    if (title) {
      document.title = title;
    }

    if (description) {
      let metaDescription = document.querySelector('meta[name="description"]') as HTMLMetaElement;
      if (!metaDescription) {
        metaDescription = document.createElement("meta");
        metaDescription.name = "description";
        document.head.appendChild(metaDescription);
      }
      metaDescription.content = description;
    }

    // Cleanup
    return () => {
      linkCanonical.remove();
      if (metaRobots && !title && !description) {
        metaRobots.content = "";
      }
    };
  }, [path, title, description]);
};

export default usePublicPageSeo;
